module.exports = __webpack_public_path__ + "static/media/Restrooms.f3b1bdf1.webp";